import { useQuery } from "@tanstack/react-query";

import { fetchAddressSuggestions } from "../../../api/fetchAddressSuggestions";
import { useSalesContext } from "../../../sales-context/SalesContext";

export const useAddressSearch = (searchText: string, isEnabled = true) => {
    const { logger, apiClients } = useSalesContext();

    return useQuery({
        queryKey: ["address-lookup", searchText],
        queryFn: async () => fetchAddressSuggestions(apiClients.sales, logger, searchText),
        retry: false,
        enabled: isEnabled,
    });
};
